exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".headerLogo__logo___2_anx {\n  cursor: pointer;\n  height: 44px;\n  margin: 0; }\n", ""]);

// exports
exports.locals = {
	"logo": "headerLogo__logo___2_anx"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":false,"minimize":true,"importLoaders":2,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["./src"]}!./src/components/HeaderLogo/headerLogo.scss
// module id = 3970
// module chunks = 6